import React from 'react';
import { useTranslation } from 'react-i18next';

import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { IconScout } from '@/components/ui/images/IconScout';
import Table from '@/components/ui/tables/Table';
import { useProgressivityList } from '@/hooks/attendance';
import { PermissionGuard } from '@/components/layout';


export const AttendanceConfigurationWorkdayTab: React.FC = () => {
  const { t: translate } = useTranslation('attendance');
  const { rows, columns, actions, loading, handleCreate } = useProgressivityList();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-start">
        <PermissionGuard action="create">
          <PrimaryButton iconLeft={<IconScout name="plus" />} onClick={handleCreate}>
            {translate('configuration.workday.actions.create')}
          </PrimaryButton>
        </PermissionGuard>
      </div>

      <Table
        columns={columns}
        data={rows}
        totalRows={rows.length}
        isLoading={loading}
        actions={actions}
      />
    </div>
  );
};

export default AttendanceConfigurationWorkdayTab;
